module.exports = __webpack_public_path__ + "img/Sistema-Vestuario-Roupas.09818f1c.jpg";